import { render, staticRenderFns } from "./classical-dashboard-new.vue?vue&type=template&id=3d6e16d9"
import script from "./classical-dashboard-new.vue?vue&type=script&lang=js"
export * from "./classical-dashboard-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports